import React from 'react';
import { Card, Stack, Typography, Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

interface ComplianceRateCardProps {
  value: number;
}

const ComplianceRateCard: React.FC<ComplianceRateCardProps> = ({ value }) => {
  return (
    <Card sx={{ flex: 1, minWidth: { xs: '100%', sm: 200 }, border: '1px solid #e2e8f0' }} elevation={0}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2 }}>
        <Stack spacing={0.5}>
          <Typography variant="body2" sx={{ color: '#64748b' }}>Compliance Rate</Typography>
          <Typography variant="h4" sx={{ fontWeight: 600, color: '#1e293b' }}>{value.toFixed(1)}%</Typography>
        </Stack>
        <Box sx={{
          width: 48, height: 48, borderRadius: '50%',
          backgroundColor: '#10b98115', display: 'flex',
          alignItems: 'center', justifyContent: 'center'
        }}>
          <CheckCircleOutlineIcon sx={{ color: '#10b981', fontSize: 28 }} />
        </Box>
      </Stack>
    </Card>
  );
};

export default ComplianceRateCard;
